import type { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

import { leadScoringAgentQueryKeys } from "../key-factory/factory";

import type { ILeadScoringQueryClient, ILeadScoringQueryClientDeps } from "./types";

export const createLeadScoringQueryClient = ({ queryClient }: ILeadScoringQueryClientDeps): ILeadScoringQueryClient => {
    const invalidateAllSummaries = (): Promise<void> => {
        return queryClient.invalidateQueries({
            queryKey: leadScoringAgentQueryKeys.allSummaries(),
        });
    };

    const invalidateAllQueries = (): Promise<void> => {
        return queryClient.invalidateQueries({
            queryKey: leadScoringAgentQueryKeys.all(),
        });
    };

    const invalidateConfigQueries = (configType: ScoringConfigType): Promise<void> => {
        return queryClient.invalidateQueries({
            queryKey: leadScoringAgentQueryKeys.config(configType),
        });
    };

    return {
        invalidateAllSummaries,
        invalidateAllQueries,
        invalidateConfigQueries,
    };
};
